export const FAILED_FETCH_DYNAMICALLY_IMPORT_MODULE =
  'Failed to fetch dynamically imported module' as const;
